$(document).ready(function() {
    var maxItems = 5;

    if (localStorage.getItem("addedItems") === null) {
        localStorage.setItem("addedItems", 0);
        localStorage.setItem("selectedProducts", JSON.stringify([]));
    }

    var addedItems = parseInt(localStorage.getItem("addedItems"));
    var selectedProducts = JSON.parse(localStorage.getItem("selectedProducts"));

    function updateDisplayItems() {
      if(addedItems<=0){
        $('.selected_samples').addClass('hidebar');
      }else{
        $('.selected_samples').removeClass('hidebar');
      }
      
      $('.wrapallinput').html('');
        $('#DropitemsBundle').find('li').each(function(index) {
            if (index < addedItems) {
                var product = selectedProducts[index];
                $(this).html('<div class="sample_img ' + product.unique + '"><img src="' + product.ProductImage + '"> <span class="remove_sample custRightBtn" data-remove="' + product.unique + '"><img src="https://cdn.shopify.com/s/files/1/0876/8051/6413/files/untitled_2.png?v=1721119283"></span><h5>' + product.product_name + '</h5></div>');
            } else {
                $(this).html('<div class="sample_img"></div>');
            }
        });
         var getproducts = JSON.parse(localStorage.getItem("selectedProducts"));
    getproducts.forEach(function(prd) {
      $('.wrapallinput').append(`<input class="${prd.unique}" type="hidden" value="${prd.variant_id}" name="id[]">`);
    })
    }

    function shiftItems() {
        var listItems = $('#DropitemsBundle').find('li');
        var emptyIndex = -1;
        listItems.each(function(index) {
            if ($(this).html() === '' && emptyIndex === -1) {
                emptyIndex = index;
            } else if (emptyIndex !== -1 && $(this).html() !== '') {
                listItems.eq(emptyIndex).html($(this).html());
                $(this).html('<div class="sample_img"></div>');
                emptyIndex++;
            }
        });
    }

    function removeItemHandler(unique) {
        var $parentLi = $('#DropitemsBundle').find('li .'+unique).closest('li');
        $parentLi.html('<div class="sample_img"></div>');
        $('input.' + unique).remove();
        $('.additem_bundle[data-unique="' + unique + '"]').attr('disabled', false);
        $('.additem_bundle[data-unique="' + unique + '"]').closest('li').removeClass('active');
        $('.additem_bundle[data-unique="' + unique + '"]').closest('li').find('.isactive').hide();
        $('.popadditem_bundle[data-unique="' + unique + '"]').text('Add to cart');

        // Update local storage
        selectedProducts = selectedProducts.filter(product => product.unique !== unique);
        addedItems--;
        localStorage.setItem("addedItems", addedItems);
        localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));

        shiftItems();
        updateDisplayItems();

        if (addedItems < maxItems) {
            $(".additem_bundle").prop('disabled', false);
            $('.addtocart_custom').addClass('hide');
        }

        updateHiddenInputNames();
    }

    function updateHiddenInputNames() {
        $('.addtocart_custom').siblings('input[type="hidden"]').each(function(index) {
            $(this).attr('name', 'id[]');
        });
    }

    function addProductToBundle(unique, product_name, ProductImage, variant_id) {
        var nextIndex = addedItems;
        $("#DropitemsBundle").find('li').eq(nextIndex).html('<div class="sample_img ' + unique + '"><img src="' + ProductImage + '"> <span class="remove_sample custRightBtn" data-remove="' + unique + '"><img src="https://cdn.shopify.com/s/files/1/0876/8051/6413/files/untitled_2.png?v=1721119283"></span><h5>' + product_name + '</h5></div>');
      $('.wrapallinput').html('');
        // $('.addtocart_custom').after('<input class="' + unique + '" type="hidden" value="' + variant_id + '" name="id[]">');
        selectedProducts.push({ unique, product_name, ProductImage, variant_id });
        addedItems++;
        localStorage.setItem("addedItems", addedItems);
        localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));

        updateDisplayItems();
      var getproducts = JSON.parse(localStorage.getItem("selectedProducts"));
    getproducts.forEach(function(prd) {
      $('.wrapallinput').append(`<input class="${prd.unique}" type="hidden" value="${prd.variant_id}" name="id[]">`);
    })
        if (addedItems >= maxItems) {
            $('.addtocart_custom').removeClass('hide');
        } else {
            $('.addtocart_custom').addClass('hide');
        }
    }

    $('body').on('click', '.additem_bundle', function() {
        var checkmax = localStorage.getItem("addedItems");
        var ProductImage = $(this).parent('li').find('img').attr('src');
        var unique = $(this).attr('data-unique');
        var product_name = $(this).attr('data-product_name');
        var variant_id = $(this).attr('data-variant_id');
   if (checkmax == maxItems) {
            if (!$('.sample_product_grid,.collection_temp').find('li.' + unique).hasClass('active')) {
                var exeedpopup = document.getElementById('Exceedlimitpopup');
                exeedpopup.style.display = "flex";
            }
        }
        if ($(this).parent('li').hasClass('active')) {
            $(this).parent('li').removeClass('active');
            $(this).parent('li').find('.isactive').hide();
            removeItemHandler(unique);
        } else {
            if (addedItems >= maxItems) return;
            $(this).parent('li').addClass('active');
            $(this).parent('li').find('.isactive').show();
            addProductToBundle(unique, product_name, ProductImage, variant_id);
            $(this).attr('disabled', true);
        }
    });

    $('body').on('click', '.popadditem_bundle', function() {
    var checkmax = localStorage.getItem("addedItems");
    var unique = $(this).attr('data-unique');
    var product_name = $(this).attr('data-product_name');
    var variant_id = $(this).attr('data-variant_id');
    var ProductImage = $(this).closest('.custom_quick_view').find('img.RightSideimg').attr('src');
    
    // Retrieve the selected products from local storage
    var selectedProducts = JSON.parse(localStorage.getItem("selectedProducts"));

    console.log(checkmax, unique, product_name, variant_id, ProductImage);

    if (checkmax == maxItems) {
        if (!$('.sample_product_grid,.collection_temp').find('li.' + unique).hasClass('active')) {
            var exeedpopup = document.getElementById('Exceedlimitpopup');
            exeedpopup.style.display = "flex";
        }
    }
    var isAlreadySelected = selectedProducts.some(function(product) {
        return product.unique === unique;
    });

    if (isAlreadySelected || $('.sample_product_grid,.collection_temp').find('li.' + unique).hasClass('active')) {
        $('.sample_product_grid,.collection_temp').find('li.' + unique).removeClass('active');
        $('.sample_product_grid,.collection_temp').find('li.' + unique).find('.isactive').hide();
        removeItemHandler(unique);
        $(this).text('Add to Cart');
    } else {
        // Add the product if it's not already selected
        if (addedItems >= maxItems) return;
        $(this).text('Remove From Cart');
        $('.sample_product_grid,.collection_temp').find('li.' + unique).addClass('active');
        $('.sample_product_grid,.collection_temp').find('li.' + unique).find('.isactive').show();
        addProductToBundle(unique, product_name, ProductImage, variant_id);
    }
});


    $('body').on('click', '.custRightBtn', function() {
        var unique = $(this).data('remove');
        removeItemHandler(unique);
    });

    function addMultipleVariantsToCart(variants) {
        var items = variants.map(function(variant) {
            return {
                id: variant.id,
                quantity: variant.quantity
            };
        });

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { items: items },
            dataType: 'json',
            success: function() {
                window.location.href = '/cart';
            },
            error: function(XMLHttpRequest, textStatus) {
                console.log('Error: ' + textStatus);
            }
        });
    }

    $('body').on('click', '#PlaceSampleOrder', function() {
        $(this).attr('disabled', true);
        $(this).parents('').find('.place-error').text('');
        var isselcted = $('.variantcount').find('input[name="id[]"]').length;
        if (isselcted > 0) {
            $('.loading__spinner').show();
            var variants = [];
            $('.variantcount').find('input[name="id[]"]').each(function() {
                variants.push({
                    id: $(this).val(),
                    quantity: 1
                });
            });
            addMultipleVariantsToCart(variants);
        } else {
            $(this).attr('disabled', false);
            $(this).parents('').find('.place-error').text('please select at least one product');
        }
    });

    $('body').on('click', '.pickfrompopup', function() {
        let crid = $(this).parent().data('id');
        $(this).closest('.product_details').find(`.details_content[data-id="${crid}"]`).addClass('activeprd').siblings().removeClass('activeprd');
        var selctedImg = $(this).find('img').attr('src');
        $(this).parents('.modal-body').find('.RightSideimg').attr('src',selctedImg);
        $(this).parents('.product_details').find('ul li').removeClass('active');
        var variant_id = $(this).attr('data-variant_id');
        var unique = $(this).attr('data-unique');
        var product_name = $(this).attr('data-product_name');
        $(this).closest('.product_details').find('.custom_quick_view_title').html(product_name);
        var addedlength = $('body').find('#DropitemsBundle .' + unique).length;
        $(this).parent('li').addClass('active');
        if (addedlength > 0) {
            $(this).parents('.product_details').find('.PopupAddtocart').text('Remove from cart');
        } else {
            $(this).parents('.product_details').find('.PopupAddtocart').text('Add to cart');
        }
        $(this).parents('.product_details').find('.PopupAddtocart').attr('data-variant_id', variant_id);
        $(this).parents('.product_details').find('.PopupAddtocart').attr('data-unique', unique);
        $(this).parents('.product_details').find('.PopupAddtocart').attr('data-product_name', product_name);
        $(this).parents('.product_details').find('.PopupAddtocart').addClass('popadditem_bundle');
    });

    $('body').on('click', '.FrabricDetail', function() {
        var id = $(this).attr('data-id');
        if (id) {
            openmodal(id);
        }
    });

    $('body').on('click', '.CloseQuick', function() {
        var id = $(this).attr('data-id');
        if (id) {
            closemodal(id);
        }
    });

    function openmodal(id) {
        var modal = document.getElementById(id);
        modal.style.display = "flex";
    }

    function closemodal(id) {
        var modal = document.getElementById(id);
        modal.style.display = "none";
    }

    // Initial setup on page load
    updateDisplayItems();
    selectedProducts.forEach(function(product) {
        $('.additem_bundle[data-unique="' + product.unique + '"]').parent('li').addClass('active');
        $('.additem_bundle[data-unique="' + product.unique + '"]').attr('disabled', true);
        $('.additem_bundle[data-unique="' + product.unique + '"]').parent('li').find('.isactive').show();
    });
});
